/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Selection_LabelInputs */



/**
* | output |
* | --- |
* | "Export Event Selection" |
*
* @param {Audio_Description_Export_Selection_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_selection_label = /** @type {((inputs?: Audio_Description_Export_Selection_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Selection_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter la sélection d'événements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Export-Ereignisauswahl")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta selezione evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выбор экспортируемого события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Selección de eventos de exportación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出事件选择")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント選択のエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात इवेंट चयन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Seleção de Eventos de Exportação")
	return /** @type {LocalizedString} */ ("Export Event Selection")
});